import { Text } from 'components/Text'
import styled from 'styled-components'

export const RelationshipsContainer = styled.div`
  margin-top: 50px;
  padding-left: 30px;
  padding-right: 48px;
`

export const RelationshipItemText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`

export const RelationshipModalContent = styled.div`
  margin: 25px 0;
`

export const RelationshipFooter = styled.div`
  margin-top: 50px;
`
export const RelationshipTitle = styled.h6`
  margin: 0;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.fontSecondary};
`

export const RelationshipFooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
`
